import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Hero from '../sections/Hero';
import ServicesSelector from '../sections/ServicesSelector';
import Testimonials from '../sections/Testimonials';
import CTABanner from '../sections/CTABanner';

const Home = () => (
  <div data-testid="home-page">
    <Navbar />
    <main>
      <Hero />
      <ServicesSelector />
      <Testimonials />
      <CTABanner />
    </main>
    <Footer />
  </div>
);

export default Home;
